import Box from '@mui/joy/Box'
import Typography from '@mui/joy/Typography'

export const Error = ({ message }) => {
    let msg = message ? message : 'An error occurred...'

    return (
        <Box
            sx={{
                display: 'flex',
                flex: 1,
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <Typography color="neutral" level="body-lg">
                {msg}
            </Typography>
        </Box>
    )
}
